import ClientCollection from './ClientCollection';

export default ClientCollection;



// WEBPACK FOOTER //
// ./src/components/ClientCollection/index.js